import DfbIconAdd from '@dfb/shared/icons/dfb-icon-add.svg';
import DfbIconArrowDown from '@dfb/shared/icons/dfb-icon-arrow-down.svg';
import DfbIconArrowLeftDown from '@dfb/shared/icons/dfb-icon-arrow-left-down.svg';
import DfbIconArrowLeftUp from '@dfb/shared/icons/dfb-icon-arrow-left-up.svg';
import DfbIconArrowLeft from '@dfb/shared/icons/dfb-icon-arrow-left.svg';
import DfbIconArrowRightDown from '@dfb/shared/icons/dfb-icon-arrow-right-down.svg';
import DfbIconArrowRightUp from '@dfb/shared/icons/dfb-icon-arrow-right-up.svg';
import DfbIconArrowRight from '@dfb/shared/icons/dfb-icon-arrow-right.svg';
import DfbIconArrowUp from '@dfb/shared/icons/dfb-icon-arrow-up.svg';
import DfbIconAttention from '@dfb/shared/icons/dfb-icon-attention.svg';
import DfbIconAudioFile from '@dfb/shared/icons/dfb-icon-audio-file.svg';
import DfbIconAusdauer from '@dfb/shared/icons/dfb-icon-ausdauer.svg';
import DfbIconBookmark from '@dfb/shared/icons/dfb-icon-bookmark.svg';
import DfbIconBeweglichkeit from '@dfb/shared/icons/dfb-icon-beweglichkeit.svg';
import DfbIconBewegungsanalyseBiomechanik from '@dfb/shared/icons/dfb-icon-bewegungsanalyse-biomechanik.svg';
import DfbIconCamera from '@dfb/shared/icons/dfb-icon-camera.svg';
import DfbIconCalender from '@dfb/shared/icons/dfb-icon-calendar.svg';
import DfbIconCheck from '@dfb/shared/icons/dfb-icon-check.svg';
import DfbIconCheckCircle from '@dfb/shared/icons/dfb-icon-check-circle.svg';
import DfbIconClearFolder from '@dfb/shared/icons/dfb-icon-clear-folder.svg';
import DfbIconClose from '@dfb/shared/icons/dfb-icon-close.svg';
import DfbIconCloud from '@dfb/shared/icons/dfb-icon-cloud.svg';
import DfbIconCoaching from '@dfb/shared/icons/dfb-icon-coaching.svg';
import DfbIconComment from '@dfb/shared/icons/dfb-icon-comment.svg';
import DfbIconCommentOutline from '@dfb/shared/icons/dfb-icon-comment-outline.svg';
import DfbIconCopy from '@dfb/shared/icons/dfb-icon-copy.svg';
import DfbIconDelete from '@dfb/shared/icons/dfb-icon-delete.svg';
import DfbIconDeleteCircle from '@dfb/shared/icons/dfb-icon-delete-circle.svg';
import DfbIconDownload from '@dfb/shared/icons/dfb-icon-download.svg';
import DfbIconDropdownDown from '@dfb/shared/icons/dfb-icon-dropdown-down.svg';
import DfbIconDropdownLeft from '@dfb/shared/icons/dfb-icon-dropdown-left.svg';
import DfbIconDropdownRight from '@dfb/shared/icons/dfb-icon-dropdown-right.svg';
import DfbIconDropdownUp from '@dfb/shared/icons/dfb-icon-dropdown-up.svg';
import DfbIconDualeKarriere from '@dfb/shared/icons/dfb-icon-duale-karriere.svg';
import DfbIconEnlarge from '@dfb/shared/icons/dfb-icon-enlarge.svg';
import DfbIconEreader from '@dfb/shared/icons/dfb-icon-ereader.svg';
import DfbIconEdit from '@dfb/shared/icons/dfb-icon-edit.svg';
import DfbIconFavourite from '@dfb/shared/icons/dfb-icon-favourite.svg';
import DfbIconFavouriteDeleted from '@dfb/shared/icons/dfb-icon-favourite-deleted.svg';
import DfbIconFile from '@dfb/shared/icons/dfb-icon-file.svg';
import DfbIconFolderOpen from '@dfb/shared/icons/dfb-icon-folder-open.svg';
import DfbIconFolderOpenShared from '@dfb/shared/icons/dfb-icon-folder-open-shared.svg';
import DfbIconFolderClosed from '@dfb/shared/icons/dfb-icon-folder-closed.svg';
import DfbIconFolderClosedShared from '@dfb/shared/icons/dfb-icon-folder-closed-shared.svg';
import DfbIconFacebook from '@dfb/shared/icons/dfb-icon-facebook.svg';
import DfbIconFacebookOutline from '@dfb/shared/icons/dfb-icon-facebook-outline.svg';
import DfbIconForward from '@dfb/shared/icons/dfb-icon-forward.svg';
import DfbIconHeadphones from '@dfb/shared/icons/dfb-icon-headphones.svg';
import DfbIconHeart from '@dfb/shared/icons/dfb-icon-heart.svg';
import DfbIconHome from '@dfb/shared/icons/dfb-icon-home.svg';
import DfbIconInformation from '@dfb/shared/icons/dfb-icon-information.svg';
import DfbIconInstagram from '@dfb/shared/icons/dfb-icon-instagram.svg';
import DfbIconKaelte from '@dfb/shared/icons/dfb-icon-kaelte.svg';
import DfbIconLeistungspsychologie from '@dfb/shared/icons/dfb-icon-leistungspsychologie.svg';
import DfbIconLinkedin from '@dfb/shared/icons/dfb-icon-linkedin.svg';
import DfbIconLinkedinOutline from '@dfb/shared/icons/dfb-icon-linkedin-outline.svg'
import DfbIconLocked from '@dfb/shared/icons/dfb-icon-locked.svg';
import DfbIconMail from '@dfb/shared/icons/dfb-icon-mail.svg';
import DfbIconMark from '@dfb/shared/icons/dfb-icon-mark.svg';
import DfbIconMenu from '@dfb/shared/icons/dfb-icon-menu.svg';
import DfbIconMove from '@dfb/shared/icons/dfb-icon-move.svg';
import DfbIconMusic from '@dfb/shared/icons/dfb-icon-music.svg';
import DfbIconMute from '@dfb/shared/icons/dfb-icon-mute.svg';
import DfbIconNavigation from '@dfb/shared/icons/dfb-icon-navigation.svg';
import DfbIconNewFolder from '@dfb/shared/icons/dfb-icon-new-folder.svg';
import DfbIconNext from '@dfb/shared/icons/dfb-icon-next.svg';
import DfbIconNotification from '@dfb/shared/icons/dfb-icon-notification.svg';
import DfbIconPauseCircle from '@dfb/shared/icons/dfb-icon-pause-circle.svg';
import DfbIconPause from '@dfb/shared/icons/dfb-icon-pause.svg';
import DfbIconPhysiologie from '@dfb/shared/icons/dfb-icon-physiologie.svg';
import DfbIconPlayCircleLarge from '@dfb/shared/icons/dfb-icon-play-circle-large.svg';
import DfbIconPlayCircle from '@dfb/shared/icons/dfb-icon-play-circle.svg';
import DfbIconPlay from '@dfb/shared/icons/dfb-icon-play.svg';
import DfbIconPodcast from '@dfb/shared/icons/dfb-icon-podcast.svg';
import DfbIconPrevious from '@dfb/shared/icons/dfb-icon-previous.svg';
import DfbIconRecord from '@dfb/shared/icons/dfb-icon-record.svg';
import DfbIconReload from '@dfb/shared/icons/dfb-icon-reload.svg';
import DfbIconRemove from '@dfb/shared/icons/dfb-icon-remove.svg';
import DfbIconResearchgate from '@dfb/shared/icons/dfb-icon-researchgate.svg';
import DfbIconReturn from '@dfb/shared/icons/dfb-icon-return.svg';
import DfbIconRewind from '@dfb/shared/icons/dfb-icon-rewind.svg';
import DfbIconSave from '@dfb/shared/icons/dfb-icon-save.svg';
import DfbIconSchnelligkeit from '@dfb/shared/icons/dfb-icon-schnelligkeit.svg';
import DfbIconSearch from '@dfb/shared/icons/dfb-icon-search.svg';
import DfbIconSend from '@dfb/shared/icons/dfb-icon-send.svg';
import DfbIconSettings from '@dfb/shared/icons/dfb-icon-settings.svg';
import DfbIconShare from '@dfb/shared/icons/dfb-icon-share.svg';
import DfbIconSoundWave from '@dfb/shared/icons/dfb-icon-soundwave.svg';
import DfbIconSportoekonomie from '@dfb/shared/icons/dfb-icon-sportoekonomie.svg';
import DfbIconStop from '@dfb/shared/icons/dfb-icon-stop.svg';
import DfbIconTaktikSpielanalyse from '@dfb/shared/icons/dfb-icon-taktik-spielanalyse.svg';
import DfbIconTalentfoerderung from '@dfb/shared/icons/dfb-icon-talentfoerderung.svg';
import DfbIconTechnologieEquipment from '@dfb/shared/icons/dfb-icon-technologie-equipment.svg';
import DfbIconTwitterOutline from '@dfb/shared/icons/dfb-icon-twitter-outline.svg';
import DfbIconTwitter from '@dfb/shared/icons/dfb-icon-twitter.svg';
import DfbIconUnlocked from '@dfb/shared/icons/dfb-icon-unlocked.svg';
import DfbIconUpload from '@dfb/shared/icons/dfb-icon-upload.svg';
import DfbIconUserProfile from '@dfb/shared/icons/dfb-icon-user-profile.svg';
import DfbIconVideo from '@dfb/shared/icons/dfb-icon-video.svg';
import DfbIconView from '@dfb/shared/icons/dfb-icon-view.svg';
import DfbIconVolumeHigh from '@dfb/shared/icons/dfb-icon-volume-high.svg';
import DfbIconVolumeLow from '@dfb/shared/icons/dfb-icon-volume-low.svg';
import DfbIconVolumeMid from '@dfb/shared/icons/dfb-icon-volume-mid.svg';
import DfbIconWhen from '@dfb/shared/icons/dfb-icon-when.svg';
import DfbIconWhere from '@dfb/shared/icons/dfb-icon-where.svg';
import DfbIconXingOutline from '@dfb/shared/icons/dfb-icon-xing-outline.svg';
import DfbIconXing from '@dfb/shared/icons/dfb-icon-xing.svg';
import DfbIconYoutube from '@dfb/shared/icons/dfb-icon-youtube.svg';
import DfbIconZoomIn from '@dfb/shared/icons/dfb-icon-zoom-in.svg';
import DfbIconZoomOut from '@dfb/shared/icons/dfb-icon-zoom-out.svg';
import {SVGProps} from 'react';

export const DfbAddSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconAdd className="dfb-Symbol dfb-Symbol--dfbIconAdd" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowDownSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowDown className="dfb-Symbol dfb-Symbol--dfbIconArrowDown" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowLeftDownSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowLeftDown className="dfb-Symbol dfb-Symbol--dfbIconArrowLeftDown" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowLeftUpSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowLeftUp className="dfb-Symbol dfb-Symbol--dfbIconArrowLeftUp" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowLeftSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowLeft className="dfb-Symbol dfb-Symbol--dfbIconArrowLeft" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowRightDownSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowRightDown className="dfb-Symbol dfb-Symbol--dfbIconArrowRight" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowRightUpSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowRightUp className="dfb-Symbol dfb-Symbol--dfbIconArrowRightUp" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowRightSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowRight className="dfb-Symbol dfb-Symbol--dfbIconArrowRight" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbArrowUpSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconArrowUp className="dfb-Symbol dfb-Symbol--dfbIconArrowUp" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbAttentionSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconAttention className="dfb-Symbol dfb-Symbol--dfbIconAttention" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbAudioFileSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconAudioFile className="dfb-Symbol dfb-Symbol--dfbIconAudioFile" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbAusdauerSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconAusdauer className="dfb-Symbol dfb-Symbol--dfbIconAusdauer" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbBeweglichkeitSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconBeweglichkeit className="dfb-Symbol dfb-Symbol--dfbIconBeweglichkeit" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbBewegungsanalyseBiomechanikSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconBewegungsanalyseBiomechanik className="dfb-Symbol dfb-Symbol--dfbIconBewegungsanalyseBiomechanik" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbBookmarkSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconBookmark className="dfb-Symbol dfb-Symbol--dfbIconBookmark" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbCameraSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCamera className="dfb-Symbol dfb-Symbol--dfbIconCamera" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCalenderSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCalender className="dfb-Symbol dfb-Symbol--dfbIconCalendar" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCheckSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCheck className="dfb-Symbol dfb-Symbol--dfbIconCheck" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCheckCircleSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCheckCircle className="dfb-Symbol dfb-Symbol--dfbIconCheckCircle" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbClearFolderSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconClearFolder className="dfb-Symbol dfb-Symbol--dfbIconClearFolder" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCloseSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconClose className="dfb-Symbol dfb-Symbol--dfbIconClose" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCloudSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCloud className="dfb-Symbol dfb-Symbol--dfbIconCloud" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCoachingSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCoaching className="dfb-Symbol dfb-Symbol--dfbIconCoaching" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCommentSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconComment className="dfb-Symbol dfb-Symbol--dfbIconComment" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCommentOutlineSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCommentOutline className="dfb-Symbol dfb-Symbol--dfbIconCommentOutline" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbCopySymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconCopy className="dfb-Symbol dfb-Symbol--dfbIconCopy" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbDeleteSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDelete className="dfb-Symbol dfb-Symbol--dfbIconDelete" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbDeleteCircleSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDeleteCircle className="dfb-Symbol dfb-Symbol--dfbIconDeleteCircle" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbDownloadSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDownload className="dfb-Symbol dfb-Symbol--dfbIconDownload" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbDropdowmDownSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDropdownDown className="dfb-Symbol dfb-Symbol--dfbIconDropdownDown" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbDropdownLeftSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDropdownLeft className="dfb-Symbol dfb-Symbol--dfbIconDropdownLeft" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbDropdownRightSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDropdownRight className="dfb-Symbol dfb-Symbol--dfbIconDropdownRight" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbDropdownUpSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDropdownUp className="dfb-Symbol dfb-Symbol--dfbIconDropdownUp" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbDualeKarriereSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconDualeKarriere className="dfb-Symbol dfb-Symbol--dfbIconDualeKarriere" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbEditSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconEdit className="dfb-Symbol dfb-Symbol--dfbIconEdit" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbEnlargeSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconEnlarge className="dfb-Symbol dfb-Symbol--dfbIconEnlarge" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbEreaderSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconEreader className="dfb-Symbol dfb-Symbol--dfbIconEreader" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbFacebookSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFacebook className="dfb-Symbol dfb-Symbol--dfbIconFacebook" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFacebookOutlineSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFacebookOutline className="dfb-Symbol dfb-Symbol--dfbIconFacebookOutline" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFavouriteSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFavourite className="dfb-Symbol dfb-Symbol--dfbIconFavourite" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFavouriteDeletedSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFavouriteDeleted className="dfb-Symbol dfb-Symbol--dfbIconFavouriteDeleted" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFileSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFile className="dfb-Symbol dfb-Symbol--dfbIconFile" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFolderClosedSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFolderClosed className="dfb-Symbol dfb-Symbol--dfbIconFolderClosed" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFolderClosedSharedSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFolderClosedShared className="dfb-Symbol dfb-Symbol--dfbIconFolderClosedShared " viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFolderOpenSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFolderOpen className="dfb-Symbol dfb-Symbol--dfbIconFolderOpen" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbFolderOpenSharedSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconFolderOpenShared className="dfb-Symbol dfb-Symbol--dfbIconFolderOpenShared" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbForwardSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconForward className="dfb-Symbol dfb-Symbol--dfbIconForward" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbHeadphonesSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconHeadphones className="dfb-Symbol dfb-Symbol--dfbIconHeadphones" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbHeartSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconHeart className="dfb-Symbol dfb-Symbol--dfbIconHeart" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbHomeSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconHome className="dfb-Symbol dfb-Symbol--dfbIconHome" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbInformationSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconInformation className="dfb-Symbol dfb-Symbol--dfbIconInformation" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbInstagramSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconInstagram className="dfb-Symbol dfb-Symbol--dfbIconInstagram" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbKaelteSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconKaelte className="dfb-Symbol dfb-Symbol--dfbIconKaelte" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbLeistungspsychologieSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconLeistungspsychologie className="dfb-Symbol dfb-Symbol--dfbIconLeistungspsychologie" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbLinkedinSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconLinkedin className="dfb-Symbol dfb-Symbol--dfbIconLinkedin" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbLinkedinOutlineSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconLinkedinOutline className="dfb-Symbol dfb-Symbol--dfbIconLinkedinOutline" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbLockedSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconLocked className="dfb-Symbol dfb-Symbol--dfbIconLocked" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbMailSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconMail className="dfb-Symbol dfb-Symbol--dfbIconMail" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbMarkSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconMark className="dfb-Symbol dfb-Symbol--dfbIconMark" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbMenuSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconMenu className="dfb-Symbol dfb-Symbol--dfbIconMenu" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbMoveSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconMove className="dfb-Symbol dfb-Symbol--dfbIconMove" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbMusicSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconMusic className="dfb-Symbol dfb-Symbol--dfbIconMusic" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbMuteSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconMute className="dfb-Symbol dfb-Symbol--dfbIconMute" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbNavigationSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconNavigation className="dfb-Symbol dfb-Symbol--dfbIconNavigation" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbNewFolderSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconNewFolder className="dfb-Symbol dfb-Symbol--dfbIconNewFolder" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbNextSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconNext className="dfb-Symbol dfb-Symbol--dfbIconNext" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbNotificationSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconNotification className="dfb-Symbol dfb-Symbol--dfbIconNotification" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbPauseSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPause className="dfb-Symbol dfb-Symbol--dfbIconPause" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbPauseCircleSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPauseCircle className="dfb-Symbol dfb-Symbol--dfbIconPauseCircle" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbPhysiologieSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPhysiologie className="dfb-Symbol dfb-Symbol--dfbIconPhysiologie" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbPlaySymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPlay className="dfb-Symbol dfb-Symbol--dfbIconPlay" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbPlayCircleSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPlayCircle className="dfb-Symbol dfb-Symbol--dfbIconPlayCircle" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbPlayCircleLargeSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPlayCircleLarge className="dfb-Symbol dfb-Symbol--dfbIconPlayCircleLarge" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbPodcastSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPodcast className="dfb-Symbol dfb-Symbol--dfbIconPodcast" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbPreviousSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconPrevious className="dfb-Symbol dfb-Symbol--dfbIconPrevious" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbRecordSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconRecord className="dfb-Symbol dfb-Symbol--dfbIconRecord" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbReloadSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconReload className="dfb-Symbol dfb-Symbol--dfbIconReload" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbRemoveSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconRemove className="dfb-Symbol dfb-Symbol--dfbIconRemove" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbResearchgateSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconResearchgate className="dfb-Symbol dfb-Symbol--dfbIconResearchgate" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbReturnSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconReturn className="dfb-Symbol dfb-Symbol--dfbIconReturn" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbRewindSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconRewind className="dfb-Symbol dfb-Symbol--dfbIconRewind" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbSaveSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconSave className="dfb-Symbol dfb-Symbol--dfbIconSave" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbSearchSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconSearch className="dfb-Symbol dfb-Symbol--dfbIconSearch" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbSchnelligkeitSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconSchnelligkeit className="dfb-Symbol dfb-Symbol--dfbIconSchnelligkeit" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbSendSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconSend className="dfb-Symbol dfb-Symbol--dfbIconSend" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbSettingsSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconSettings className="dfb-Symbol dfb-Symbol--dfbIconSettings" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbShareSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconShare className="dfb-Symbol dfb-Symbol--dfbIconShare" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbSoundWaveSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconSoundWave className="dfb-Symbol dfb-Symbol--dfbIconSoundWave" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbSportoekonomieSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconSportoekonomie className="dfb-Symbol dfb-Symbol--dfbIconSportoekonomie" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbStopSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconStop className="dfb-Symbol dfb-Symbol--dfbIconStop" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbTaktikSpielanalyseSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconTaktikSpielanalyse className="dfb-Symbol dfb-Symbol--dfbIconTaktikSpielanalyse" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbTalentfoerderungSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconTalentfoerderung className="dfb-Symbol dfb-Symbol--dfbIconTalentfoerderung" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbTechnologieEquipmentSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconTechnologieEquipment className="dfb-Symbol dfb-Symbol--dfbIconTechnologieEquipment" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbTwitterSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconTwitter className="dfb-Symbol dfb-Symbol--dfbIconTwitter" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbTwitterOutlineSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconTwitterOutline className="dfb-Symbol dfb-Symbol--dfbIconTwitterOutline" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbUnlockedSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconUnlocked className="dfb-Symbol dfb-Symbol--dfbIconUnlocked" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbUploadSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconUpload className="dfb-Symbol dfb-Symbol--dfbIconUpload" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbUserProfileSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconUserProfile className="dfb-Symbol dfb-Symbol--dfbIconUserProfile" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbVideoSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconVideo className="dfb-Symbol dfb-Symbol--dfbIconVideo" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbViewSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconView className="dfb-Symbol dfb-Symbol--dfbIconView" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbVolumeHighSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconVolumeHigh className="dfb-Symbol dfb-Symbol--dfbIconVolumeHigh" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbVolumeLowSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconVolumeLow className="dfb-Symbol dfb-Symbol--dfbIconVolumeLow" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbVolumeMidSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconVolumeMid className="dfb-Symbol dfb-Symbol--dfbIconVolumeMid" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbWhenSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconWhen className="dfb-Symbol dfb-Symbol--dfbIconWhen" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbWhereSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconWhere className="dfb-Symbol dfb-Symbol--dfbIconWhere" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbXingSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconXing className="dfb-Symbol dfb-Symbol--dfbIconXing" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbXingOutlineSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconXingOutline className="dfb-Symbol dfb-Symbol--dfbIconXingOutline" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbYoutubeSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconYoutube className="dfb-Symbol dfb-Symbol--dfbIconYoutube" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};

export const DfbZoomInSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconZoomIn className="dfb-Symbol dfb-Symbol--dfbIconZoomIn" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
export const DfbZoomOutSymbol = (props: SVGProps<SVGSVGElement>) => {
    return (<DfbIconZoomOut className="dfb-Symbol dfb-Symbol--dfbIconZoomOut" viewBox="0 0 24 24" aria-hidden="true"  {...props}/>);
};
